import React, { useState, useEffect } from "react";
import Form from "../Form/Form";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

import {
  FormWrapper,
  FormNavigation,
  FormsContainer,
  FormNavigationItem,
} from "./styles";
import { colors } from "@/lib/styles/theme";
import InformationModule from "@/components/InformationModule";

export default function Forms(props: any) {
  const { formList = [] } = props;
  const router = useRouter();
  const [activeTab, setactiveTab] = useState(
    router.asPath.split("#")[1]
      ? decodeURIComponent(router.asPath.split("#")[1])
      : formList[0]?.slug
  );
  const { locale = "it" } = router;
  const t = {
    successTitle: useTranslation("contactPage.successTitle", locale) || "",
    successSubTitle:
      useTranslation("contactPage.successSubTitle", locale) || "",
    successButtonText:
      useTranslation("contactPage.successButtonText", locale) || "",
  };

  if (router.query.success) {
    return (
      <InformationModule
        title={t.successTitle}
        subTitle={t.successSubTitle}
        buttonText={t.successButtonText}
        redirectTo={"/contacts"}
      />
    );
  }

  return (
    <FormWrapper>
      <FormNavigation>
        {formList.map((item: any, indx: any) => (
          <FormNavigationItem
            as={"a"}
            href={`#${item.slug}`}
            data-id={item._id}
            key={item.form.heading + Math.random()}
            onClick={() => setactiveTab(item.slug)}
            textColor={
              (activeTab == null && indx == 0) || item.slug == activeTab
                ? colors.red
                : colors.darkMiddle
            }
          >
            {item.form.heading}
          </FormNavigationItem>
        ))}
      </FormNavigation>
      <FormsContainer>
        {formList.map((item: any, indx: number) =>
          (activeTab == null && indx == 0) || item.slug == activeTab ? (
            <Form key={item._id + Math.random()} {...item} />
          ) : null
        )}
      </FormsContainer>
    </FormWrapper>
  );
}
